import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';

import { cn } from '@/lib/utils';

type BooleanValueProps = {
  value: boolean;
};

export const BooleanValue = (props: BooleanValueProps) => {
  const { value } = props;
  const { t } = useTranslation();

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 text-sm',
        value ? 'text-foreground' : 'text-muted-foreground',
      )}
    >
      {value ? (
        <Check className="text-success-soft-foreground size-4 shrink-0" />
      ) : (
        <X className="size-4 shrink-0" />
      )}
      {t(value ? 'Yes' : 'No')}
    </span>
  );
};
